<template>
  <MDBNavbar expand="lg" dark bg="dark" container>
    <MDBNavbarBrand href="#">Home</MDBNavbarBrand>
    <MDBNavbarToggler
      @click="collapse1 = !collapse1"
      target="#navbarSupportedContent"
    ></MDBNavbarToggler>
    <MDBCollapse v-model="collapse1" id="navbarSupportedContent">
      <MDBNavbarNav collapse="navbarNav" class="d-flex">
        <MDBNavbarItem to="/world" active> World </MDBNavbarItem>
        <MDBNavbarItem to="/sanctum" active>
          Sanctum of Alteration
        </MDBNavbarItem>
        <MDBNavbarItem to="/enemy" active> Enemy List </MDBNavbarItem>
      </MDBNavbarNav>
    </MDBCollapse>
  </MDBNavbar>
  <MDBModal
    id="exampleModal"
    tabindex="-1"
    labelledby="exampleModalLabel"
    :modelValue="exampleModal"
    size="lg"
  >
    <MDBModalHeader>
      <MDBModalTitle>Warning</MDBModalTitle>
    </MDBModalHeader>
    <MDBModalBody
      ><h1>
        This site is Deprecated, please use
        <a href="https://lomap.vercel.app/">this</a> instead.
      </h1></MDBModalBody
    >
    <MDBModalFooter>
      <MDBBtn color="secondary" @click="exampleModal = false">Close</MDBBtn>
    </MDBModalFooter>
  </MDBModal>
  <Suspense>
    <template #default>
      <div class="container p-4">
        <router-view :key="$route.path" />
      </div>
    </template>
    <template #fallback>Loading... </template>
  </Suspense>
</template>

<script>
import {
  MDBNavbar,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarBrand,
  MDBCollapse,
  MDBModal,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBModalHeader,
  MDBModalTitle,
} from "mdb-vue-ui-kit";
import { ref } from "vue";

export default {
  components: {
    MDBNavbar,
    MDBNavbarToggler,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarBrand,
    MDBCollapse,
    MDBModal,
    MDBModalBody,
    MDBModalFooter,
    MDBBtn,
    MDBModalHeader,
    MDBModalTitle,
  },
  setup() {
    const collapse1 = ref(false);
    const exampleModal = ref(false);
    return {
      collapse1,
      exampleModal,
    };
  },
  mounted() {
    this.exampleModal = true;
  },
};
</script>

<style lang="scss">
@import "~@/../mdb/scss/index.free.scss";

#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.click-card {
  cursor: pointer;
}
</style>
